import { render, staticRenderFns } from "./WarehouseDetails.vue?vue&type=template&id=0a9ea043&scoped=true"
import script from "./WarehouseDetails.vue?vue&type=script&lang=js"
export * from "./WarehouseDetails.vue?vue&type=script&lang=js"
import style0 from "./WarehouseDetails.vue?vue&type=style&index=0&id=0a9ea043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9ea043",
  null
  
)

export default component.exports